import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { withStyles, Paper, Typography } from "@material-ui/core";
import t from "../../../../languages/pl";
import TireChangeDate from './TireChangeDate';
import withSaveButton from './../../../HOC/withSaveButton';

const useStyles = theme => ({
    paper: {
        margin: theme.spacing(1),
        padding: theme.spacing(2)
    },
    content: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column"
    },
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: 500,
        [theme.breakpoints.down("md")]: {
            justifyContent: "center",
            flexDirection: "column"
        },
        margin: theme.spacing(1)
    }
});

const reminder1 = "przypomnienie1";
const reminder2 = "przypomnienie2";
const reminder3 = "przypomnienie3";
const reminder4 = "przypomnienie4";

const ChangeTiresSchedule = props => {
    const { classes, data, onChange } = props;
    const [internalState, setInternalState] = useState(data);

    useEffect(() => {
        setInternalState(data);
        props.onFormDataChange(data);
    }, [data]);

    useEffect(() => {
        props.onFormDataChange(internalState);
        onChange && onChange(internalState);
    }, [internalState]);

    const handleChange = (sectionName, name, value) => {
        setInternalState(prevState => ({
            ...prevState,
            [sectionName]: {
                ...prevState[sectionName],
                [name]: value
            }
        }));
    };

    return (
        <Paper
            square
            className={classes.paper}
        >
            <div>
                <Typography variant="subtitle1">
                    {t.changeTires}
                </Typography>
                <div className={classes.content}>
                    <div className={classes.row}>
                        <TireChangeDate
                            label={t.reminder1}
                            selected={internalState[reminder1].aktywne}
                            onSelect={(value) => handleChange(reminder1, "aktywne", value)}
                            day={internalState[reminder1].dzien}
                            onDayChange={(value) => handleChange(reminder1, "dzien", value)}
                            month={internalState[reminder1].miesiac}
                            onMonthChange={(value) => handleChange(reminder1, "miesiac", value)}
                        />
                        <TireChangeDate
                            label={t.reminder2}
                            selected={internalState[reminder2].aktywne}
                            onSelect={(value) => handleChange(reminder2, "aktywne", value)}
                            day={internalState[reminder2].dzien}
                            onDayChange={(value) => handleChange(reminder2, "dzien", value)}
                            month={internalState[reminder2].miesiac}
                            onMonthChange={(value) => handleChange(reminder2, "miesiac", value)}
                        />
                    </div>
                    <div className={classes.row}>
                        <TireChangeDate
                            label={t.reminder3}
                            selected={internalState[reminder3].aktywne}
                            onSelect={(value) => handleChange(reminder3, "aktywne", value)}
                            day={internalState[reminder3].dzien}
                            onDayChange={(value) => handleChange(reminder3, "dzien", value)}
                            month={internalState[reminder3].miesiac}
                            onMonthChange={(value) => handleChange(reminder3, "miesiac", value)}
                        />
                        <TireChangeDate
                            label={t.reminder4}
                            selected={internalState[reminder4].aktywne}
                            onSelect={(value) => handleChange(reminder4, "aktywne", value)}
                            day={internalState[reminder4].dzien}
                            onDayChange={(value) => handleChange(reminder4, "dzien", value)}
                            month={internalState[reminder4].miesiac}
                            onMonthChange={(value) => handleChange(reminder4, "miesiac", value)}
                        />
                    </div>
                </div>
            </div>
        </Paper>
    );
};

ChangeTiresSchedule.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    onChange: PropTypes.func,
    //withSaveButton
    onFormDataChange: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    withSaveButton
)(ChangeTiresSchedule);
